import React from "react";
import * as styles from "./CardIcon.module.scss";
import { getCreditCardType } from "utilities/helpers";
import { cx } from "class-variance-authority";
import { MethodIcon } from "../method-row/MethodIcon";
import { ReactComponent as MastercardIcon } from "assets/logos/mastercard.svg";
import { ReactComponent as VisaIcon } from "assets/logos/visa.svg";

type CardIconProps = {
  card: {
    numberFirst: string;
    numberLast: string;
    expired: boolean;
  };
};

export const CardIcon = ({ card }: CardIconProps) => {
  const cardType = getCreditCardType(card.numberFirst);

  return (
    <MethodIcon
      className={cx(
        styles.cardIcon,
        cardType === "visa" ? styles.visa : styles.mastercard,
        card.expired ? styles.expired : undefined,
      )}
    >
      <div className={styles.icon}>
        {cardType === "visa" ? <VisaIcon /> : <MastercardIcon />}
      </div>
      <span className={styles.lastFour}>**{card.numberLast}</span>
    </MethodIcon>
  );
};
